<template>
  <ModalDialog title="Features de cuenta" :open="isOpen" @close="$emit('close')">
    <AccountFeaturesConfig :account="account" />
  </ModalDialog>
</template>

<script lang="ts" setup>
//Components
import AccountFeaturesConfig from "@organisms/Account/AccountFeatures/AccountFeaturesConfig.vue";
import ModalDialog from "@molecules/ModalDialog.vue";

//Props
withDefaults(
  defineProps<{
    isOpen?: boolean;
    account?: string;
  }>(),
  {
    isOpen: false,
    account: undefined,
  }
);

//Emits
defineEmits<{
  (e: "close"): void;
}>();
</script>
